import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Quote from "components/Typography/Quote.jsx";
// core components

import SectionDestacadas from "KComponents/SectionDestacadas.jsx";
import SectionRecents from "KComponents/SectionRecents.jsx";

import sectionTextStyle from "assets/jss/material-kit-pro-react/views/blogPostSections/sectionTextStyle.jsx";

function SectionText({ ...props }) {
  const { classes } = props;
  const { featured } = props;
  const { recents } = props;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>
            Whether you’re looking to buy, sell, let or rent, our residential specialists are with you every step of the way, ensuring a smooth process and helpful communication at every stage.
          </h3>
          <p>
            Kinos International's Residential Services team is one of the leading private real estate advisors, especially in the upscale segment, thanks to its many years of experience and in-depth knowledge of the market.
Looking to buy, sell or develop residential property?
Kinos offer comprehensive advice on the sale or rental of property to both institutional landlords and private clients  from pricing to the necessary documentation. We create marketing concepts, market analyses and advertising plans. We also advise on floor plan design and equipment quality in the context of real estate projects.
Kinos will give you our individualized, comprehensive support during the entire duration of the search for your dream property  and when we have found it, help you negotiate the purchase or rental contracts to make sure your dream is protected.
            <br />
            <br />
              Whether you’re looking to buy, sell, let or rent, our residential specialists are with you every step of the way, ensuring a smooth process and helpful communication at every stage.

  Our advice is always honest and clear. Through each negotiation, we share our expertise and resources with all parties, answering questions and liaising with solicitors from start to finish.

  Our specialist residential teams can help too, with in-depth experience in a range of industries and areas, from country and equestrian houses, to waterfront property and new developments.
          </p>
          <Quote
            textClassName={classes.quoteText}
            text="“Excellence is our Goal, customers satisfaction our proud!”"
            author="Joaquín Morales, CEO."
          />
        </GridItem>
        <GridItem xs={12} sm={10} md={10} className={classes.section}>
          <SectionDestacadas featured={featured}  url="residential" />
          <SectionRecents recents={recents}  url="residential" />
        </GridItem>

        <GridItem xs={12} sm={8} md={8} id="search" >
        </GridItem>

      </GridContainer>
    </div>
  );
}

export default withStyles(sectionTextStyle)(SectionText);
